import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from "react-select";
import Pagination from '../../../Components/Pagination/Pagination';
import { assignedTenderStatus, changeDepartmentApi, deleteTenderApi, getAssignedTenders, getDepartments, selectedTotalDepartments } from '../../../Redux/Action/Dashboard';
import { TableStyles, departmentStyles, fileBaseUrl, formatDate, getUserDetail, tenderDate } from '../../../Utils/Helper';
import Loader from '../../../Utils/Loader';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import { MdOutlineClose } from 'react-icons/md';

const AssignedTenders = () => {
    const dispatch = useDispatch();

    const [show, setShow] = useState(false)
    const [proceedTender, setProceedTender] = useState({
        tenderId: '',
        status: ''
    })
    const [selectedTenderId, setSelectedTenderId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [changeDepartment, setChangeDepartment] = useState({
        tender_id: null,
        department_id: null
    });
    const [showDepartmentPopup, setShowDepartmentPopup] = useState(false);

    const [deleteDepartment, setDeleteDepartment] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const { loading: departmentLoading, getTotalDepartments } = useSelector((state) => state.selectedTendersDepartments)
    const { loading: Loading, assignedTenderData } = useSelector((state) => state.assignedTendersGet)
    const { loading: getDepartmentLoading, getDepartmentsData } = useSelector((state) => state.departmentsGet)
    const { loading: deleteLoading, deleteTenderData, error: deleteError } = useSelector((state) => state.getDeletedTender)
    const { loading: changeDepartmentLoading, changeDepartmentData, error: changeDepartError } = useSelector((state) => state.getChangeDepartment)

    const { loading: assignLoading, assignedTenderSelectData, error: assignError } = useSelector((state) => state.selectAssignedTenders)

    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [limit])

    useEffect(() => {
        dispatch(getDepartments())
    }, [])

    useEffect(() => {
        const formData = new FormData();
        formData.append("department_id", getUserDetail()?.department_id);
        dispatch(getAssignedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit));

        dispatch(selectedTotalDepartments());

        return () => {
            dispatch({ type: "GET_ALL_ASSIGNED_TENDERS_RESET" });
            dispatch({ type: "ASSIGNED_TENDER_STATUS_RESET" });
        }
    }, []);

    useEffect(() => {
        if (selectedDepartment?.value === "all") {
            dispatch(getAssignedTenders({}, currentPage, limit))
        }
        else if (selectedDepartment) {
            const formData = new FormData();
            formData.append("department_id", selectedDepartment?.value);

            dispatch(getAssignedTenders(formData, currentPage, limit))
        }
        else {
            const formData = new FormData();
            formData.append("department_id", getUserDetail()?.department_id);
            dispatch(getAssignedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
        }
    }, [currentPage, limit]);

    useEffect(() => {
        if (assignedTenderSelectData?.statusCode === 200) {
            successNotify("Proceed Successfully!");
            setShow(false)

            dispatch({ type: "GET_ALL_ASSIGNED_TENDERS_RESET" })
            dispatch({ type: "ASSIGNED_TENDER_STATUS_RESET" })

            if (selectedDepartment && selectedDepartment?.value !== 'all') {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);
                dispatch(getAssignedTenders(formData, currentPage, limit));
            }
            else {
                dispatch(getAssignedTenders(null, currentPage, limit));
            }
        }
        else if (assignError) {
            errorNotify(assignError);
            dispatch({ type: "ASSIGNED_TENDER_STATUS_RESET" })
        }
    }, [assignedTenderSelectData, assignError])

    useEffect(() => {
        if (changeDepartmentData?.statusCode === 200) {
            successNotify("Change Department Successfully!");
            setShowDepartmentPopup(false)

            if (selectedDepartment && selectedDepartment?.value !== 'all') {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);
                dispatch(getAssignedTenders(formData, currentPage, limit));
            }
            else {
                const formData = new FormData();
                formData.append("department_id", getUserDetail()?.department_id);
                dispatch(getAssignedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
            }

            dispatch({ type: "CHANGE_DEPARTMENT_RESET" })
        }
        else if (changeDepartError) {
            errorNotify(changeDepartError);
            dispatch({ type: "CHANGE_DEPARTMENT_RESET" })
        }
    }, [changeDepartmentData, changeDepartError])

    useEffect(() => {
        if (deleteTenderData?.statusCode === 200) {
            successNotify("Deleted Successfully!");
            setShowDeletePopup(false)

            if (selectedDepartment && selectedDepartment?.value !== 'all') {
                const formData = new FormData();
                formData.append("department_id", selectedDepartment?.value);
                dispatch(getAssignedTenders(formData, currentPage, limit));
            }
            else {
                const formData = new FormData();
                formData.append("department_id", getUserDetail()?.department_id);
                dispatch(getAssignedTenders(getUserDetail()?.role === 'super-admin' ? {} : formData, currentPage, limit))
            }

            dispatch({ type: "DELETE_TENDER_RESET" })
        }
        else if (changeDepartError) {
            errorNotify(changeDepartError);
            dispatch({ type: "DELETE_TENDER_RESET" })
        }
    }, [deleteTenderData, changeDepartError])

    const departOption = [
        { value: 'all', label: 'Select All' },
        ...(Array.isArray(getTotalDepartments?.data)
            ? getTotalDepartments?.data?.map((d) => ({
                value: d?.id,
                label: d?.name
            }))
            : [])
    ];

    const searchDepartmentHandler = (selected) => {
        if (!selected) {
            errorNotify("Please Select Department");
            return;
        }

        setSelectedDepartment(selected);
        setCurrentPage(1);

        if (selected.value === "all") {
            dispatch(getAssignedTenders(null, 1, limit));
        } else {
            const formData = new FormData();
            formData.append("department_id", selected.value);
            dispatch(getAssignedTenders(formData, 1, limit));
        }
    };

    const proceedHandler = () => {
        if (proceedTender.tenderId && proceedTender.status) {
            const formData = new FormData();
            formData.append("selected_tender_id", proceedTender.tenderId)
            formData.append("action", proceedTender.status)

            dispatch(assignedTenderStatus(formData))
        }
    }

    const modal = <Modal show={show} centered className='logout_modal'>
        <Modal.Header onHide={() => setShow(false)}>
            <h5>Are you sure ?</h5>
            <MdOutlineClose onClick={() => {
                setShow(false)
                setSelectedTenderId(null);
            }} style={{ cursor: "pointer", fontSize: "22px" }} />
        </Modal.Header>
        <Modal.Body>
            <h3>Are you sure you are {proceedTender.status === 'yes' ? 'interested' : "not interested"} in this tender?</h3>
            <div className='d-flex justify-content-center' style={{ gap: "20px" }}>
                <button className='no_btn'
                    onClick={() => {
                        setShow(false);
                        setSelectedTenderId(null);
                    }}
                >No</button>
                <button type='button' onClick={proceedHandler} disabled={assignLoading}>
                    {assignLoading ? <Spinner animation='border' size='sm' /> : "Yes, Proceed"} </button>
            </div>
        </Modal.Body>
    </Modal>

    const options = [
        { value: "yes", label: "Interested" },
        { value: "no", label: "Not Interested" },
    ]

    const selectHandler = (value, getId) => {
        const userRole = getUserDetail()?.role;
        if (userRole === 'super-admin' || userRole === 'admin') {
            setProceedTender({
                tenderId: getId,
                status: value
            });
            setSelectedTenderId(getId);
            setShow(true);
        } else {
            errorNotify("You don't have rights for this action");
        }
    }

    const proceedDepartmentHandler = () => {
        if (changeDepartment.tender_id && changeDepartment.department_id) {
            const formData = new FormData();
            formData.append("tender_id", changeDepartment.tender_id)
            formData.append("department_id", changeDepartment.department_id)

            dispatch(changeDepartmentApi(formData))
        }
    }

    const proceedDeleteHandler = () => {
        if (deleteDepartment) {
            const formData = new FormData();
            formData.append("tender_id", deleteDepartment)

            dispatch(deleteTenderApi(formData))
        }
    }

    const departmentHandler = (value, getId) => {
        setChangeDepartment({
            tender_id: getId,
            department_id: value
        })

        setShowDepartmentPopup(true);
    }

    const deleteDepartmentHandler = (getId) => {
        setDeleteDepartment(getId)
        setShowDeletePopup(true)
    }

    const departmentDeleteModal = <Modal show={showDeletePopup} centered className='logout_modal'>
        <Modal.Header onHide={() => setShow(false)}>
            <h5>Are you sure ?</h5>
            <MdOutlineClose onClick={() => {
                setDeleteDepartment(null)
                setShowDeletePopup(false)
            }} style={{ cursor: "pointer", fontSize: "22px" }} />
        </Modal.Header>
        <Modal.Body>
            <h3>Are you sure you want to delete?</h3>
            <div className='d-flex justify-content-center' style={{ gap: "20px" }}>
                <button className='no_btn'
                    onClick={() => {
                        setDeleteDepartment(null)
                        setShowDeletePopup(false)
                    }}
                >No</button>
                <button type='button' onClick={proceedDeleteHandler} disabled={deleteLoading}>
                    {deleteLoading ? <Spinner animation='border' size='sm' /> : "Yes"} </button>
            </div>
        </Modal.Body>
    </Modal>

    const departmentModal = <Modal show={showDepartmentPopup} centered className='logout_modal'>
        <Modal.Header onHide={() => setShow(false)}>
            <h5>Are you sure ?</h5>
            <MdOutlineClose onClick={() => {
                setChangeDepartment({
                    tender_id: null,
                    department_id: null
                })
                setShowDepartmentPopup(false)
            }} style={{ cursor: "pointer", fontSize: "22px" }} />
        </Modal.Header>
        <Modal.Body>
            <h3>Are you sure you want to change the department?</h3>
            <div className='d-flex justify-content-center' style={{ gap: "20px" }}>
                <button className='no_btn'
                    onClick={() => {
                        setChangeDepartment({
                            tender_id: null,
                            department_id: null
                        })
                        setShowDepartmentPopup(false)
                    }}
                >No</button>
                <button type='button' onClick={proceedDepartmentHandler} disabled={changeDepartmentLoading}>
                    {changeDepartmentLoading ? <Spinner animation='border' size='sm' /> : "Yes"} </button>
            </div>
        </Modal.Body>
    </Modal>

    const departOptions = getDepartmentsData?.data?.length > 0 ? getDepartmentsData?.data?.map((d) => {
        return {
            value: d?.id, label: d.name
        }
    }) : []

    return (
        <div className='dashboard_main' style={{ padding: "15px 10px" }}>
            {modal}
            {departmentModal}
            {departmentDeleteModal}

            <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                Assigned Tenders
            </h1>

            {
                getUserDetail()?.role === 'super-admin' &&
                <Row className='align-items-end pb-3' style={{ borderBottom: "1px solid #8080804d" }}>
                    <Col md={3}>
                        <Form.Group className="form_field">
                            <Form.Label>Department </Form.Label>
                            <Select
                                isLoading={getDepartmentLoading}
                                onChange={searchDepartmentHandler}
                                options={departOption || []}
                                placeholder="Select Department"
                                styles={departmentStyles}
                                value={selectedDepartment}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            }

            {
                Loading ? <div className='py-3'>
                    <Loader />
                </div> :
                    <div className='application_table assigned_tenders'>
                        <Table responsive={!assignedTenderData || assignedTenderData?.data?.results?.length === 0 ? false : true}>
                            <thead>
                                <tr>
                                    <th>S No.</th>
                                    <th>Tender No.</th>
                                    <th>Company</th>
                                    <th>Department</th>
                                    <th>Advertise Date</th>
                                    <th>Due Date</th>
                                    <th>Due Time</th>
                                    <th>Download</th>
                                    {getUserDetail()?.role !== 'user' && <th>Action</th>}
                                    {getUserDetail()?.role === 'super-admin' && <th>Remove</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    assignedTenderData?.data?.results?.map((t, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td>{t.tenderNo}</td>
                                                <td style={{ maxWidth: "250px" }}>{t.company}</td>
                                                <td>{t.depart && t.depart.name}</td>
                                                <td>{formatDate(t.advertiseDate)}</td>
                                                <td className={tenderDate(t.closingDate)}>{formatDate(t.closingDate)}</td>
                                                {
                                                    t.closingTime ? <td>{t.closingTime}</td> : <td style={{ paddingLeft: "40px" }}>-</td>
                                                }
                                                <td>
                                                    {!t.document ? (
                                                        <button
                                                            className='download_doc_btn'
                                                            style={{
                                                                opacity: 0.6,
                                                                cursor: 'not-allowed',
                                                            }}
                                                            title="No Attachment Available"
                                                            disabled
                                                        >
                                                            Download
                                                        </button>
                                                    ) :
                                                        <Link to={`${fileBaseUrl}/${t.document}`} target="_blank" className='download_doc_btn'>
                                                            Download
                                                        </Link>
                                                    }
                                                </td>
                                                {
                                                    getUserDetail()?.role === 'admin' &&
                                                    <td>
                                                        <span>
                                                            <Select
                                                                placeholder="Select Actions"
                                                                options={options}
                                                                menuPortalTarget={document.body}
                                                                menuPosition='fixed'
                                                                styles={TableStyles}
                                                                onChange={(e) => selectHandler(e.value, t.id)}
                                                                value={selectedTenderId === t.id ? options.find(opt => opt.value === proceedTender.status) : null}
                                                                isDisabled={getUserDetail()?.role === 'user'}
                                                            />
                                                        </span>
                                                    </td>
                                                }
                                                {
                                                    getUserDetail()?.role === 'super-admin' &&
                                                    <td>
                                                        <span>
                                                            <Select
                                                                placeholder="Change Department"
                                                                isLoading={departmentLoading}
                                                                options={departOptions}
                                                                menuPortalTarget={document.body}
                                                                menuPosition='fixed'
                                                                styles={departmentStyles}
                                                                onChange={(e) => departmentHandler(e.value, t.id)}
                                                                value={selectedTenderId === t.id ? options.find(opt => opt.value === proceedTender.status) : null}
                                                                isDisabled={getUserDetail()?.role === 'user'}
                                                            />
                                                        </span>
                                                    </td>
                                                }
                                                {
                                                    getUserDetail()?.role === 'super-admin' &&
                                                    <td>
                                                        <span>{
                                                            <MdOutlineClose className='delete_depart_icon'
                                                                onClick={() => deleteDepartmentHandler(t.id)}
                                                                style={{ cursor: "pointer", fontSize: "22px" }} />
                                                        }</span>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>

                        {
                            assignedTenderData?.data?.results?.length > 0 &&
                            <Pagination
                                totalPages={assignedTenderData?.data?.meta?.totalPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                setLimit={setLimit}
                                limit={limit} />
                        }

                        {assignedTenderData?.data?.results?.length === 0 && <p className='text-center' style={{ fontWeight: "600" }}>No Data Found</p>}
                    </div>
            }
        </div>
    )
}
export default AssignedTenders